import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowInbox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-inbox, download, file, down, save"} maskId="square-filled-radius-0-stroke-1-IconArrowInbox"><path fillRule="evenodd" clipRule="evenodd" d="M4 14V20H20V14H21V21H3V14H4Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M12 16.2071L16.2071 12L15.5 11.2929L12.5 14.2929V3H11.5V14.2929L8.5 11.2929L7.79289 12L12 16.2071Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowInbox;
